import { Container } from './styled';
import { CardCustomerService } from '../../components';

export function ViewerCustomerServiceOpen(props) {

  const { customerServiceOpen, onClose } = props;

  return (
    <Container>
      {customerServiceOpen?.length > 0
        && customerServiceOpen?.map((customerService) => {
          return (
            <CardCustomerService
              key={customerService?.id}
              type={`Open`}
              onClose={onClose}
              customerService={customerService}
            />
          )
        })
      }
    </Container>
  );
}